export const getTotalDaySpan = transfers =>
  transfers.reduce((prev, curr) => {
    return prev + curr.days;
  }, 0);



// WEBPACK FOOTER //
// ./src/utils/transfers.js